export const DEVICE_ROLE_FILTER_OPTIONS = [
  { value: "", label: "All roles" },
  { value: "master", label: "Master" },
  { value: "slave", label: "Slave" },
];

export const ACTIVITY_TYPE_FILTER_OPTIONS = [
  { value: "", label: "All types" },
  { value: "online", label: "Online" },
  { value: "offline", label: "Offline" },
  { value: "status", label: "Status" },
];

export function normalizeDeviceRole(value) {
  const role = (value ?? "").trim().toLowerCase();
  if (role === "master" || role === "slave") return role;
  return "";
}

export function rowDeviceRole(row) {
  return (row?.deviceRole ?? row?.device_role ?? "").trim().toLowerCase();
}

export function rowMatchesDeviceRoleFilter(row, roleFilter) {
  const role = normalizeDeviceRole(roleFilter);
  if (!role) return true;
  return rowDeviceRole(row) === role;
}

export function rowMatchesActivityTypeFilter(row, typeFilter) {
  const type = (typeFilter ?? "").trim().toLowerCase();
  if (!type) return true;
  return (row?.activityType ?? "").trim().toLowerCase() === type;
}
